import { intComma } from 'humanize-plus'
import { insert } from 'ramda'
import React,
{ Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import {
  Button,
  Div,
  Footer,
  H2,
  Modal,
  P,
} from '@driftt/tide-core'
import {
  access,
  showTransientNotification
} from '@driftt/traffic-control'
import {
  archiveContactGroup,
  unsubCSV
} from 'api/contacts'
import { shouldShowMarketoImports } from 'utils/marketoAccess'

import './style.css'

const mapStateToProps = state => {
  return { selectedContacts: state.__CRM.contacts.selectedContacts }
}

const mapDispatchToProps = dispatch => {
  return {
    onSendEmail: () => dispatch(showTransientNotification({
      type: 'success',
      message: 'Your CSV is being generated now, check your email'
    })),
    onSendUnsub: () => dispatch(showTransientNotification({
      type: 'success',
      message: 'Your CSV should start downloading soon.'
    }))
  }
}

class ManageContacts extends Component {
  constructor(props) {
    super(props)

    this.state = { exportModalOpen: false }
  }

  sendUnsubCsv = async () => {
    const { onSendUnsub } = this.props

    try {
      const { data } = await unsubCSV()
      this.createCSVDownload(data, "unsubscribed")
      onSendUnsub()
    } catch(e) {
      console.warn(e)
    }
  }

  createCSVDownload = (csvData, exportName = 'export') => {
    const blobData = new Blob([csvData], { type: 'text/csv' })
    const url = URL.createObjectURL(blobData)
    const encodedUri = encodeURI(url)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', exportName + '.csv')
    document.body.appendChild(link) // Required for FF
    link.click()
  }

  deleteContacts = async () => {
    const {
      selectedContacts,
      resetContacts
    } = this.props

    try {
      await archiveContactGroup(selectedContacts)

      resetContacts()
    } catch(e) {

    }
  }

  toggleExportModal = () => {
    this.setState(prevState => ({ exportModalOpen: !prevState.exportModalOpen }))
  }

  render() {
    const {
      addNew,
      contactAttributes,
      history,
      selectedContacts,
      allContacts
    } = this.props

    const { exportModalOpen } = this.state

    let actions = [
      {
        icon: 'rolodex',
        label: 'Add single contact',
        action: (toggle) => {
          addNew()
          toggle()
        }
      },
      {
        icon: 'upload-2',
        label: 'Import CSV',
        action: (toggle) => {
          toggle()
          history.push('/imports/upload')
        }
      },
      {
        icon: 'download-2',
        label: 'Export CSV of all unsubscribes',
        action: (toggle) => {
          toggle()
          this.sendUnsubCsv()
        }
      }
    ]

    const marketoImportAction = {
      icon: 'upload-2',
      label: 'Import Marketo Lists',
      action: (toggle) => {
        toggle()
        history.push('/imports/marketo')
      }
    }

    if (shouldShowMarketoImports()) {
      actions = insert(2, marketoImportAction, actions)
    }

    const contactAttributeSelection = {
      icon: 'user',
      label: 'Contact Attributes',
      action: () => contactAttributes()
    }

    if (access.hasGates('BETA_GLOBAL_ATTRIBUTES')) {
      actions.push(contactAttributeSelection)
    }

    const deleteSelected = {
      icon: 'trash',
      label: 'Delete selected contacts',
      action: this.deleteContacts
    }

    if (selectedContacts.length > 0) {
      actions.push(deleteSelected)
    }

    return (
      <Div className="contacts-list-manage--container">
        <Button onClick={() => history.push('/imports')}>
          Import contacts
        </Button>

        <Modal
          size="small"
          open={exportModalOpen}
          onClose={this.toggleExportModal}
          title="Export your contacts"
          className="contacts-list-manage--export-modal"
        >
          <H2>{`We'll email you your export of all ${intComma(allContacts)} contacts`}</H2>
          <P>This might take a while. Hang tight and the download will appear in your inbox as soon as it's ready.</P>
          <Footer>
            <Button type="primary" onClick={() => {
              this.toggleExportModal()
            }
            }>
              Request Download
            </Button>
            <Button type="subtle" onClick={this.toggleExportModal}>Cancel</Button>
          </Footer>
        </Modal>
      </Div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageContacts))
